

import React, { useEffect } from 'react'
import { MuiGrid, MuiTypography, MuiAppBar, MuiTextField, MuiToolbar, MuiButton, MuiFormHelperText, MuiAutocomplete } from '../../ui/MaterialUIComponents';
import { makeStyles } from '@material-ui/core/styles';
import '../../ui/scrollbarForLog.css'
import theme from '../../../assests/theme';
import spinner from "../../ui/icons/spinner.gif";
import IndividualTimeTableGrid from '../school/timeTable/IndividualTimeTableGrid';
import MasterSchedule from '../school/timeTable/MasterSchedule'
import CalendarGrid from '../school/timeTable/CalendarGrid'
import { evalLicenseToShowText, calculateBlur } from '../../../utils/EvaluationUtil'

const useStyles = makeStyles(theme => ({
    timeTableGrid: { padding: 8, boxSizing: 'border-box', width: 'auto', marginTop: '64px', },
    titleStyle: { color: theme.palette.primary.main, fontWeight: 600 },
    subTitleStyle: { color: theme.palette.primary.light },
    formControl: { width: "50%" },
    selectEmpty: { marginTop: theme.spacing(2) },
    noDataFoundStyle: { height: '100vh', width: '100vw' },
    loadingImageStyle: { textDecoration: "none", height: '80px', width: '80px' },
    renderSchoolInformationRoot: { paddingTop: 16, boxSizing: 'border-box' },
    renderTimeTable: { padding: 32, boxSizing: 'border-box' },

    appbarStyle: {
        backgroundColor: 'white',
        zIndex: 1000,
    },

    noItemSelectedStyle: { height: '60vh', width: '100vw' },
}));

const Label = {
    TEACHER: "Teacher", ROOM: "Room", CLASS: "Class", MASTER_SCHEDULE: "Master Schedule",
    INDIVIDUAL_SCHEDULE: "Individual Schedule"
}
const type = {
    // TEACHER: "6guD0dyp",
    // CLASSGROUP: "CV6Z5P2c",
    // ROOM: "GYrHI5Cj",
    MASTER_SCHEDULE: "mYZkdhB0",
    MASTER_SCHEDULE_FOR_ROOMS: "f032Lyxt",
    MASTER_SCHEDULE_FOR_TEACHERS: "7GTUiJrT",
}

const masterScheduleTypes = ["mYZkdhB0", "f032Lyxt", "7GTUiJrT"]

function PublicTimeTableComponent(props) {
    const [selectedObject, setSelectedObject] = React.useState(null);
    const [scheduleType, setScheduleType] = React.useState(null);
    const classes = useStyles();
    const { i18n } = props
    let noOfTimeTableToShowIndex = null
    let noOfTimeTableForTeacherToShowIndex = null
    let noOfRoomsTimeTableToShowIndex = null
    let percentage = null
    useEffect(() => {
        setData();
    }, []);

    const geti18nText = (text) => {
        switch (text) {
            case Label.TEACHER: return i18n.publicTimeTable.teacher; break;
            case Label.ROOM: return i18n.publicTimeTable.room; break;
            case Label.CLASS: return i18n.publicTimeTable.class; break;
            default: return
        }

    }
    const setData = async () => {

        let url = window.location.pathname;
        let arr = url.split('/');

        let timeTableId = arr[arr.length - 2];
        let typeId = arr[arr.length - 1];
        if ((masterScheduleTypes.find((typeVal) => typeId == typeVal)) != undefined) {
            setScheduleType(Label.MASTER_SCHEDULE)
        }
        else {
            setScheduleType(Label.INDIVIDUAL_SCHEDULE)
        }

        await props.getTimeTableById(timeTableId, typeId);

    };

    const renderLoading = () => {

        return (
            <MuiGrid container
                justify='center'
                alignItems='center' className={classes.noDataFoundStyle}
            ><MuiGrid>
                    <img src={spinner} alt="none" className={classes.loadingImageStyle} />
                    <MuiTypography variant={theme.typographyStyles.BODY1}>
                        {i18n.publicTimeTable.loadingText}
                    </MuiTypography>
                </MuiGrid>
            </MuiGrid>
        )
    }

    const renderSchoolInformation = () => {
        return (<MuiGrid container xs={12} justify='space-between' alignItems='center' className={classes.renderSchoolInformationRoot}>

            <MuiGrid container xs>
                <MuiGrid item xs>
                    <MuiTypography variant={theme.typographyStyles.H5} className={classes.titleStyle}>
                        {props.timeTableData.school.name}
                    </MuiTypography>
                </MuiGrid>
                <MuiGrid item xs={12} >
                    <MuiTypography variant={theme.typographyStyles.BODY2} className={classes.subTitleStyle}>
                        {props.timeTableData.school.address.line1 + ',' + props.timeTableData.school.address.city}
                    </MuiTypography>
                </MuiGrid>
            </MuiGrid>
            <MuiGrid item xs>
                <MuiTypography variant={theme.typographyStyles.H6} className={classes.titleStyle}>
                    {i18n.publicTimeTable.schedule}: {props.timeTableData.school.schedule.name}
                </MuiTypography>
            </MuiGrid>
            {scheduleType != Label.MASTER_SCHEDULE &&
                <MuiGrid item xs>
                    {renderSelectMethod()}
                </MuiGrid>}


        </MuiGrid>)
    }
    function dynamicSort(property) {
        var sortOrder = 1;
        if (property[0] === "-") {
            sortOrder = -1;
            property = property.substr(1);
        }
        return function (a, b) {
            /* next line works with strings and numbers, 
             * and you may want to customize it to your needs
             */
            var result = (a[property].toUpperCase() < b[property].toUpperCase()) ? -1 : (a[property].toUpperCase() > b[property].toUpperCase()) ? 1 : 0;
            return result * sortOrder;
        }
    }
    const renderSelectMethod = () => {
        let percentage = props.timeTableData.school.license.status == 'Trial period' ? props.timeTableData.school.license.enableBlurForTrialUser ? (props.timeTableData.school.license.timetableDisplayPercentage / 100) : 1 : 1
        noOfTimeTableToShowIndex = calculateBlur(percentage, props.timeTableData.timeTable, props.timeTableData.school.license.maxNumberOfItemDisplayForTrialUser) + 1

        //  let percentage = props.timeTableData.school.license.status == 'Trial period' ? 0.4 : 1
        //    noOfTimeTableToShowIndex = (Math.round(props.timeTableData.timeTable.length * percentage))
        let allTimeTable = JSON.parse(JSON.stringify(props.timeTableData.timeTable))
        let timeTable = allTimeTable.splice(0, noOfTimeTableToShowIndex)
        if (props.timeTableData.label == Label.TEACHER) {
            timeTable = timeTable.sort(dynamicSort("firstName"));
        }
        else if (props.timeTableData.label == Label.ROOM) {
            timeTable = timeTable.sort(dynamicSort("name"));
        }
        return (< MuiGrid xs align='center'>

            <MuiAutocomplete
                className={classes.formControl}
                options={timeTable}
                getOptionLabel={(option) => (props.timeTableData.label == Label.TEACHER) ? option.firstName + " " + option.lastName + " (" + option.id + ")" : option.name}
                value={selectedObject}
                onChange={(event, newValue) => {
                    setSelectedObject(newValue)
                }}
                renderInput={params => <MuiTextField {...params} label={props.timeTableData.label} margin="normal" />}
            />
            <MuiFormHelperText className={classes.formControl}
            >{i18n.commonTexts.select + ' ' + geti18nText(props.timeTableData.label) + ' ' + i18n.commonTexts.fromList}</MuiFormHelperText>
        </ MuiGrid>)
    }

    const renderTimeTable = () => {


        return (
            <MuiGrid container xs={12} justify='center' alignItem='center'>
                <MuiGrid container xs={12} className={classes.renderTimeTable}>
                    <CalendarGrid
                        {...props}
                        title={props.timeTableData.label == Label.TEACHER ? selectedObject.firstName + " " + selectedObject.lastName + (selectedObject.groupName != undefined ? ' ( ' + i18n.commonTexts.class + ' :' + selectedObject.groupName.toUpperCase() + ')' : '') : selectedObject.name}
                        lastHourSlot={props.timeTableData.lastHourSlot} startHourSlot={props.timeTableData.startHourSlot}
                        index={0}
                        showText={showText}
                        noOfTTShowIndex={0}
                        header={props.timeTableData.headers}
                        setTitleTextStyleBasedOnLicense={setTitleTextStyleBasedOnLicense}
                        setSummaryTextStyleBasedOnLicense={setSummaryTextStyleBasedOnLicense}
                    >
                        <IndividualTimeTableGrid
                            timeTableType={props.timeTableData.key}
                            header={props.timeTableData.headers}
                            classItem={props.timeTableData.label == Label.TEACHER ? selectedObject.days : selectedObject}
                            availableTeachers={false}
                            lastHourSlot={props.timeTableData.lastHourSlot} startHourSlot={props.timeTableData.startHourSlot}
                            showText={showText}
                            cardIndex={0}
                            noOfTTShowIndex={0}
                            i18n={i18n}
                            setCellLunchTextStyleBasedOnLicense={setCellLunchTextStyleBasedOnLicense}
                            setCellTextStyleBasedOnLicense={setCellTextStyleBasedOnLicense}

                        />
                    </CalendarGrid>
                </MuiGrid></MuiGrid>
        )
    }
    const renderMasterSchedule = () => {
        let percentage = props.timeTableData.school.license.status == 'Trial period' ? props.timeTableData.school.license.enableBlurForTrialUser ? (props.timeTableData.school.license.timetableDisplayPercentage / 100) : 1 : 1

        // let percentage = props.timeTableData.school.license.status == 'Trial period' ? 0.4 : 1

        // noOfTimeTableToShowIndex = (Math.round(props.timeTableData.timeTable.length * percentage)) - 1
        noOfTimeTableToShowIndex = calculateBlur(percentage, props.timeTableData.timeTable, props.timeTableData.school.license.maxNumberOfItemDisplayForTrialUser)

        return (
            <MuiGrid container xs={12} justify='center' alignItem='center'>
                <MuiGrid container xs={12} style={{ padding: "24px 24px 0 24px" }}>

                    <MasterSchedule  {...props}
                        header={props.timeTableData.headers}
                        timeTable={props.timeTableData.timeTable}
                        roomsTimeTable={props.timeTableData.timeTable}
                        timeTableForTeacher={props.timeTableData.timeTable}
                        timeTableType={props.timeTableData.key}
                        noOfTimeTableToShowIndex={noOfTimeTableToShowIndex}
                        noOfTimeTableForTeacherToShowIndex={noOfTimeTableToShowIndex}
                        noOfRoomsTimeTableToShowIndex={noOfTimeTableToShowIndex}
                        showText={showText}
                        height='80vh'
                        i18n={i18n}
                    />
                </MuiGrid></MuiGrid>
        )
    }
    function showText(name, timeTableType, index) {
        if (scheduleType === Label.MASTER_SCHEDULE) {
            return evalLicenseToShowText(name, noOfTimeTableToShowIndex, index)
        }
        else {
            return name
        }
    }
    function setSummaryTextStyleBasedOnLicense(index1, index) {
        return {}
    }
    function setTitleTextStyleBasedOnLicense(index1, index) {
        return theme.titleTextStyleForTT
    }
    function setCellTextStyleBasedOnLicense(index1, index) {
        return theme.cellTextStyleForTT
    }
    function setCellLunchTextStyleBasedOnLicense(index1, index) {
        return theme.cellLunchTextStyleForTT
    }


    return (
        <MuiGrid container >

            <MuiAppBar classes={{
                root: classes.appbarStyle
            }}>
                <MuiToolbar>
                    <MuiGrid justify='space-between' container spacing={24} >
                        <MuiGrid item>
                            {/* <MuiButton color='inherit' style={theme.appBarTextItem}> */}
                            <a href="https://www.schoolpivot.com/" target="_blank">
                                <img src={theme.imageAlbum.toolbarLogo} style={theme.appLogoStyle}

                                /></a>
                            {/* </MuiButton> */}
                        </MuiGrid>
                    </MuiGrid>
                </MuiToolbar>
            </MuiAppBar>
            {props.getTimeTableInProgress ?
                renderLoading()
                :
                props.timeTableData.label != null && props.getTimeTableFailed == false ?
                    <MuiGrid xs={12} className={classes.timeTableGrid} id='scrollStyleWithoutDisplay'>
                        {renderSchoolInformation()}
                        {scheduleType != Label.MASTER_SCHEDULE ?
                            selectedObject != null ? renderTimeTable()
                                :
                                <MuiGrid container xs={12}
                                    justify='center'
                                    alignItems='center' className={classes.noItemSelectedStyle}>
                                    <MuiGrid xs={4} >
                                        <MuiTypography variant={theme.typographyStyles.BODY1} color="primary">
                                            {i18n.commonTexts.select + ' ' + props.timeTableData.label + ' ' + i18n.commonTexts.fromDropDown}
                                        </MuiTypography>
                                    </MuiGrid>
                                </MuiGrid> : renderMasterSchedule()
                        }
                    </MuiGrid>
                    :
                    <MuiGrid container
                        justify='center'
                        alignItems='center' className={classes.noDataFoundStyle}>
                        <MuiGrid>
                            <MuiTypography variant={theme.typographyStyles.BODY1}>
                                {i18n.publicTimeTable.noTimeTableText}
                            </MuiTypography>
                        </MuiGrid>
                    </MuiGrid>

            }

        </MuiGrid>
    )

}


export default PublicTimeTableComponent
